<template>
  <div class="loader-container">
    <div class="loader">
      <p>
        Por favor espera un momento mientras preparamos a <strong>Cindy</strong>, 
        nuestra inteligencia artificial entrenada exclusivamente para ayudarte 
        con este sistema.
      </p>
    </div>
    <button v-if="!isLoading" class="continue-button" @click="$emit('continue')">Continuar</button>
  </div>
</template>
v

<script>
export default {
  props: {
    isLoading: {
      type: Boolean,
      required: true
    }
  }
};
</script>

<style scoped>
.loader-container {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.9);
  z-index: 10;
  display: flex;
  justify-content: center;
  align-items: center;
}

.loader {
  color: #fff;
  text-align: center;
  font-size: 1.3rem;
  font-family: 'Arial', sans-serif;
  line-height: 1.5;
  max-width: 80%;
  width: 600px;
  height: 40%; /* Espacio limitado para animación */
  overflow: hidden; /* Oculta lo que se sale */
  position: relative;
}

.loader p {
  margin: 0;
  animation: moveUp 5s ease-in-out infinite;
  position: absolute;
  width: 100%;
}


.continue-button {
  position: absolute;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
  padding: 10px 20px;
  font-size: 1rem;
  color: #000;
  background-color: #fff;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  z-index: 2;
  bottom: 5%;
}

@keyframes moveUp {
  0% {
    top: 60px;
  }
  50% {
    top: 0px;
  }
  100% {
    top: 60px;
  }
}

</style>